import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { usePreApproval } from '../../pages/LandingPage';

const ClientFavoriteService = () => {
  const { openPreApproval } = usePreApproval();

  return (
    <section className="py-16 md:py-24 bg-slate-900 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-cyan-500/30 to-transparent" />
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-emerald-500/30 to-transparent" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-cyan-500/5 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Content */}
        <p className="text-emerald-400 text-xl font-semibold mb-3">Our #1 Client-Favorite Service</p>
        
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
          High-Converting Custom Landing Pages
          <span className="block text-cyan-400 mt-2">— Built Just Like This One</span>
        </h2>
        
        <p className="text-slate-400 text-lg md:text-xl leading-relaxed max-w-3xl mx-auto mb-10">
          From websites and funnels to full web apps and mobile apps, we build exactly what your business needs to scale — with videos, forms, AI bots, automations, and integrations built in.
        </p>

        {/* Big CTA Button */}
        <Button
          onClick={openPreApproval}
          size="lg"
          data-testid="client-favorite-cta-btn"
          className="w-full sm:w-auto sm:min-w-[400px] bg-emerald-500 hover:bg-emerald-400 text-white font-bold px-12 py-8 text-xl rounded-2xl transition-all hover:shadow-2xl hover:shadow-emerald-500/30 hover:-translate-y-1 group"
        >
          Get Your Dream App or Site
          <ArrowRight className="ml-3 w-6 h-6 group-hover:translate-x-1 transition-transform" />
        </Button>
      </div>
    </section>
  );
};

export default ClientFavoriteService;
